import React from 'react';
import BackgroundBig from '../../assets/img/ellipsis_mega_big.png';

const BasicProfileInformation = props => {
  const subtitleFontSize = props.subtitle?.length > 60 ? 14 : props.subtitle?.length > 40 ? 16 : props.subtitle?.length > 20 ? 18 : 22;
  return (
    <>
      <div
        className='basic-clinic-info'
        style={{
          backgroundImage: `url(${BackgroundBig})`,
          backgroundSize: '120%',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'left bottom',
          position: 'relative'
        // backgroundColor: '#FFF1A7'
        }}
      >

        <h1 style={{ marginTop: 50, wordWrap: 'break-word', hyphens: 'manual' }} className={`profile-title${props.title.length > 70 ? ' mega-small' : props.title.length > 54 ? ' smallst' : props.title.length > 18 ? ' smaller' : ''}`}>{props.title}</h1>
        {
        props.subtitle && <h4 className='profile-subtitle' style={{ fontSize: subtitleFontSize }}>{props.subtitle}</h4>
      }
        <div style={{ width: '100%', height: 12 }} />
        <div className='profile-information-list'>
          <table>
            <tbody>
              {
              props.informationList.map(({ icon, info }, i) => {
                return (
                  <tr key={i}>
                    <td>
                      <center>{icon}</center>
                    </td>
                    <td>
                      {info}
                    </td>
                  </tr>
                );
              })
            }
            </tbody>
          </table>
        </div>
        <div style={{ width: '100%', height: 48 }} />
      </div>
    </>
  );
};

export default BasicProfileInformation;
